export default "__VITE_ASSET__3TboA07l__"